import { render, staticRenderFns } from "./GroupStatistic.vue?vue&type=template&id=33a39bf8&scoped=true&"
import script from "./GroupStatistic.vue?vue&type=script&lang=js&"
export * from "./GroupStatistic.vue?vue&type=script&lang=js&"
import style0 from "./GroupStatistic.vue?vue&type=style&index=0&id=33a39bf8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a39bf8",
  null
  
)

export default component.exports